// Merge a (re-)download result into the Done-screen viewer state.
//
// The server deletes the passphrase right after first delivery, so a
// re-download comes back keyless (consumed=true, passphrase=""). But if we
// already showed the passphrase on THIS screen, we must keep displaying it —
// the user may not have saved it yet, and wiping it would be a data-loss trap.
// Only fall to the keyless "consumed" note when we genuinely have no passphrase
// (a fresh page-load re-download, where prior state is empty).

export type ViewerState = {
  sizeBytes: number;
  passphrase: string;
  consumed?: boolean;
};

export type DownloadResult = {
  sizeBytes: number;
  passphrase: string;
  consumed: boolean;
};

export function resolveViewerAfterDownload(
  prior: ViewerState | undefined,
  incoming: DownloadResult,
): ViewerState {
  const knownPass = incoming.passphrase || prior?.passphrase || "";
  return {
    sizeBytes: incoming.sizeBytes,
    passphrase: knownPass,
    // "consumed" (hide the key, show the note) only when we truly have none.
    consumed: incoming.consumed && !knownPass,
  };
}
